import { defineComponent as o, openBlock as r, createBlock as c, unref as d, mergeProps as p, withCtx as l, createElementVNode as e } from "vue";
import { RevIcon as v } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconReassuranceAdyen",
  __name: "IconReassuranceAdyen",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const t = n;
    return (f, a) => (r(), c(d(v), p(t, { "view-box": "0 0 48 48" }), {
      default: l(() => [...a[0] || (a[0] = [
        e("g", { "clip-path": "url(#6eea7d8d-97ac-491f-9c16-f52a897caf26a)" }, [
          e("path", {
            "fill-rule": "evenodd",
            d: "M12 16v-4a12 12 0 0 1 24 0v4h3.15A3.81 3.81 0 0 1 43 19.77v24.46A3.81 3.81 0 0 1 39.15 48H8.85A3.81 3.81 0 0 1 5 44.23V19.77A3.81 3.81 0 0 1 8.85 16H12m20 0v-4a8 8 0 0 0-16 0v4h16M18.89 40.55h13.66v-13.7a3.43 3.43 0 0 0-3.44-3.44H15.74v4.3h8.79a1 1 0 0 1 .95 1v7.58h-1.91a1 1 0 0 1-.95-1v-5.44h-3.73a3.43 3.43 0 0 0-3.44 3.41v3.85a3.43 3.43 0 0 0 3.44 3.44",
            "clip-rule": "evenodd"
          })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "6eea7d8d-97ac-491f-9c16-f52a897caf26a" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
